// extracted by mini-css-extract-plugin
export default {"wrapper":"MinerHashSetting_wrapper__p33h2","link":"MinerHashSetting_link__5-4i6"};